import { ResellersFilterFormValues } from "../components";
import {
  AGE_FROM_FILTER_SEARCH_PARAMETER,
  AGE_TO_FILTER_SEARCH_PARAMETER,
  CANCELED_FROM_FILTER_SEARCH_PARAMETER,
  CANCELED_TO_FILTER_SEARCH_PARAMETER,
  DELETE_STATUS_FILTER_SEARCH_PARAMETER,
  DELIVERED_FROM_FILTER_SEARCH_PARAMETER,
  DELIVERED_TO_FILTER_SEARCH_PARAMETER,
  EARNINGS_FROM_FILTER_SEARCH_PARAMETER,
  EARNINGS_TO_FILTER_SEARCH_PARAMETER,
  GENDER_FILTER_SEARCH_PARAMETER,
  RETURNED_FROM_FILTER_SEARCH_PARAMETER,
  RETURNED_TO_FILTER_SEARCH_PARAMETER,
  SALES_FROM_FILTER_SEARCH_PARAMETER,
  SALES_TO_FILTER_SEARCH_PARAMETER,
  VERIFICATION_FILTER_SEARCH_PARAMETER
} from "../constants";

export const getResellersFilterNewSearchParams = ({
  verification,
  deleteStatus,
  gender,
  ageFrom,
  ageTo,
  totalEarningsFrom,
  totalEarningsTo,
  totalSalesFrom,
  totalSalesTo,
  numberOfCanceledOrdersFrom,
  numberOfCanceledOrdersTo,
  numberOfDeliveredOrdersFrom,
  numberOfDeliveredOrdersTo,
  numberOfReturnedOrdersFrom,
  numberOfReturnedOrdersTo
}: ResellersFilterFormValues) => {
  const newSearchParams: Record<string, string | string[]> = {};

  if (verification != null)
    newSearchParams[VERIFICATION_FILTER_SEARCH_PARAMETER] = verification;

  if (deleteStatus != null)
    newSearchParams[DELETE_STATUS_FILTER_SEARCH_PARAMETER] = deleteStatus;

  if (gender != null) newSearchParams[GENDER_FILTER_SEARCH_PARAMETER] = gender;

  if (ageFrom != null)
    newSearchParams[AGE_FROM_FILTER_SEARCH_PARAMETER] = String(ageFrom);

  if (ageTo != null)
    newSearchParams[AGE_TO_FILTER_SEARCH_PARAMETER] = String(ageTo);

  if (totalEarningsFrom != null)
    newSearchParams[EARNINGS_FROM_FILTER_SEARCH_PARAMETER] =
      String(totalEarningsFrom);

  if (totalEarningsTo != null)
    newSearchParams[EARNINGS_TO_FILTER_SEARCH_PARAMETER] =
      String(totalEarningsTo);

  if (totalSalesFrom != null)
    newSearchParams[SALES_FROM_FILTER_SEARCH_PARAMETER] =
      String(totalSalesFrom);

  if (totalSalesTo != null)
    newSearchParams[SALES_TO_FILTER_SEARCH_PARAMETER] = String(totalSalesTo);

  if (numberOfCanceledOrdersFrom != null)
    newSearchParams[CANCELED_FROM_FILTER_SEARCH_PARAMETER] = String(
      numberOfCanceledOrdersFrom
    );

  if (numberOfCanceledOrdersTo != null)
    newSearchParams[CANCELED_TO_FILTER_SEARCH_PARAMETER] = String(
      numberOfCanceledOrdersTo
    );

  if (numberOfDeliveredOrdersFrom != null)
    newSearchParams[DELIVERED_FROM_FILTER_SEARCH_PARAMETER] = String(
      numberOfDeliveredOrdersFrom
    );

  if (numberOfDeliveredOrdersTo != null)
    newSearchParams[DELIVERED_TO_FILTER_SEARCH_PARAMETER] = String(
      numberOfDeliveredOrdersTo
    );

  if (numberOfReturnedOrdersFrom != null)
    newSearchParams[RETURNED_FROM_FILTER_SEARCH_PARAMETER] = String(
      numberOfReturnedOrdersFrom
    );

  if (numberOfReturnedOrdersTo != null)
    newSearchParams[RETURNED_TO_FILTER_SEARCH_PARAMETER] = String(
      numberOfReturnedOrdersTo
    );

  newSearchParams.page = "1";

  return newSearchParams;
};
